const Helper = {
  getShortDate: (date) => {
    const d = new Date(date);

    if (d) {
      // Extract date components
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');

      // Format the date as "YYYY-MM-DD"
      return `${year}-${month}-${day}`;
    } else return '';
  },

  convertServerDate: (serverDateString) => {
    try {
      const serverDate = new Date(serverDateString);

      // Options for formatting the date
      const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };

      // Format the date as a string
      const formattedDate = serverDate.toLocaleDateString(undefined, options);

      return formattedDate ?? '';
    } catch (error) {
      console.error('Error converting server date:', error);
      return serverDateString;
    }
  },

  getPlanFeatures: (planLookupKey) => {
    /* eslint-disable indent */
    switch (planLookupKey) {
      case 'chatbuddy-monthly-starter':
      case 'chatbuddy-annual-starter':
        return [
          '3 Chatbots',
          '1000 conversations per month',
          '5M characters of training data per bot',
          'Embed on unlimited websites',
          'Use your own branding',
          'GPT 3.5',
          'Connect to Documents, Spreadsheets, Text',
          'View conversation history',
          'Multilingual Chatbot',         
        ];
      case 'chatbuddy-monthly-pro':
      case 'chatbuddy-annual-pro':
        return [
          '50 Chatbots',
          '1000 conversations per month',
          '10M characters of training data per bot',   
          'Embed on unlimited websites',       
          'Use your own branding',
          'GPT 4',
          'Connect to Documents, Spreadsheets, Text',
          'View conversation history',
          'Multilingual Chatbot',  
        ];
      case 'chatbuddy-monthly-premium':
      case 'chatbuddy-annual-premium':
        return [
          '10  Chatbots',
          '5000 conversations per month',
          '10M characters of training data per bot',
          'Embed on unlimited websites',
          'Use your own branding',
          'GPT 3.5',
          'Connect to Documents, Spreadsheets, Text',
          'View conversation history',
          'Multilingual Chatbot', 
        ];
      case 'chatbuddy-business-plan':
        return [
          'No limit on number of chatbots*',
          'Unlimited conversations*',
          'No training data size limit *',
          'Embed on unlimited websites',
          'Use your own branding',
          'GPT 3.5/GPT 4',
          'Unlimited data sources (also available via API)',
          'View conversation history',
          'Multilingual Chatbot',
        ];
      default:
        return [
          '1 Chatbot',
          '100 conversations per month',
          '1M characters of training data per bot',
          'Embed on unlimited websites',
          'Use your own branding',
          'GPT 3.5',
          'Connect to Documents, Spreadsheets, Text',
          'View conversation history',
          'Multilingual Chatbot',
        ];
    }
  },

};

export default Helper;
